export default "__VITE_ASSET__CBFUaU_w__"